import { Cancel, Check } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface ConfirmDialogProps {
  title: string;
  message?: string;
  handleClose: (confirmation: boolean) => void;
  isOpen: boolean;
}

function ConfirmDialog(props: ConfirmDialogProps) {
  const { title, message = "", handleClose, isOpen } = props;

  return (
    <Dialog open={isOpen} onClose={() => handleClose(false)}>
      <DialogTitle>{title}</DialogTitle>
      {message ? (
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions>
        <Button
          size="small"
          onClick={() => handleClose(false)}
          color="primary"
          variant="outlined"
          startIcon={<Cancel />}
        >
          Cancel
        </Button>
        <Button
          size="small"
          onClick={() => handleClose(true)}
          color="secondary"
          variant="contained"
          autoFocus
          startIcon={<Check />}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default ConfirmDialog;
